import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'input', 'form']

  connect() {
    // console.log("Hello, Search Controller here!", this.element);
    // console.log(this.inputTarget);
    // console.log(this.formTarget);

    this.inputTarget.addEventListener('search', this.clearSearch.bind(this));
  }

  clearSearch(event) {
    event.preventDefault();

    if (event.target.value.length === 0) {
      event.target.value = '';

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.delete('search');
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.location.href = newUrl;
    }
  }

  attemptSubmit(event) {
    this.formTarget.submit();
  }

}
